import type { QueryClient } from '@tanstack/react-query';

export function invalidateUploadState(client: QueryClient, published = false) {
  const invalidations = [
    client.invalidateQueries({ queryKey: ['uploads'] }),
    client.invalidateQueries({ queryKey: ['admin', 'jobs'] })
  ];
  if (published) {
    invalidations.push(client.invalidateQueries({ queryKey: ['feed'] }));
    invalidations.push(client.invalidateQueries({ queryKey: ['me'] }));
  }
  return Promise.all(invalidations);
}

export function invalidateMediaState(client: QueryClient, mediaId: string, removed = false) {
  if (removed) client.removeQueries({ queryKey: ['media', mediaId] });
  const invalidations = [
    client.invalidateQueries({ queryKey: ['feed'] }),
    client.invalidateQueries({ queryKey: ['me'] }),
    client.invalidateQueries({ queryKey: ['uploads'] }),
    client.invalidateQueries({ queryKey: ['download-jobs'] }),
    client.invalidateQueries({ queryKey: ['admin', 'deleted'] }),
    client.invalidateQueries({ queryKey: ['admin', 'jobs'] }),
    client.invalidateQueries({ queryKey: ['admin', 'audit'] })
  ];
  if (!removed) invalidations.push(client.invalidateQueries({ queryKey: ['media', mediaId] }));
  return Promise.all(invalidations);
}

export function invalidateCurationState(client: QueryClient, mediaId?: string) {
  const invalidations = [
    client.invalidateQueries({ queryKey: ['collections'] }),
    client.invalidateQueries({ queryKey: ['feed'] }),
    client.invalidateQueries({ queryKey: ['admin', 'collections'] }),
    client.invalidateQueries({ queryKey: ['admin', 'audit'] })
  ];
  if (mediaId) invalidations.push(client.invalidateQueries({ queryKey: ['media', mediaId] }));
  return Promise.all(invalidations);
}
